/**
 * Clerk `publicMetadata.role` values used by the app.
 * Backend may use `super_admin`; tolerate common typo `supper_admin`.
 */
export function isSuperAdminRole(role: string | undefined | null): boolean {
  if (!role || typeof role !== "string") return false;
  const normalized = role.trim().toLowerCase();
  return normalized === "super_admin" || normalized === "supper_admin";
}

export function isVpRole(role: string | undefined | null): boolean {
  if (!role || typeof role !== "string") return false;
  const normalized = role.trim().toLowerCase();
  return normalized === "vp";
}

/** Super admin + VP — manager dropdown, all managers, optional manager_email on APIs. */
export function isManagerDashboardElevatedRole(
  role: string | undefined | null,
): boolean {
  return isSuperAdminRole(role) || isVpRole(role);
}

export function isManagerRole(role: string | undefined | null): boolean {
  if (!role || typeof role !== "string") return false;
  const normalized = role.trim().toLowerCase();
  return normalized === "manager";
}

/** Manager dashboard page access: manager, VP, or super admin. */
export function isManagerDashboardRole(role: string | undefined | null): boolean {
  return isManagerRole(role) || isManagerDashboardElevatedRole(role);
}

export function isManagerOrSuperAdminRole(
  role: string | undefined | null,
): boolean {
  return isManagerDashboardRole(role);
}
